export default __webpack_public_path__ + "static/media/markets_title.36cc5d70.svg";